export default class WelcomeHeader {

    static searchBoxContainerSelector = ".promo_staticcontent-widget--welcome-header_search-box-container";

    constructor() {
        this.loginContainer = document.querySelector(".promo_staticcontent-widget--welcome-header_login");
        this.searchBar = document.querySelector(WelcomeHeader.searchBoxContainerSelector);
        this.welcomeText = document.querySelector(".promo_staticcontent-widget--welcome-header_login > h1")

        /*                                                                                                                                                                                     */
        document.body.style.backgroundColor = "#f0f0f0";

        window.addEventListener("scroll", () => {
            const loginContainerClientRect = this.loginContainer.getBoundingClientRect();
            if (loginContainerClientRect.y + loginContainerClientRect.height < 0) {
                this.searchBar.style.position = 'fixed';
                /*                                                                                                                              */
                this.loginContainer.style.marginBottom = '56px';
            } else {
                this.searchBar.style.position = 'relative';
                this.loginContainer.style.marginBottom = '0';
            }
        });
        /*                                                                                                                                                                      */
        window.addEventListener("beforeunload", () => {
            this.searchBar.style.display = 'none';
        });

        this.updateWelcomeHeaderWithFirstName();
    }

    triggerNativeSearch() {
        document.dispatchEvent(new Event("open.appNativeSearch"));
    }

    updateWelcomeHeaderWithFirstName() {

        if (this.welcomeText.innerHTML !== "Willkommen zurück" || this.welcomeText.getAttribute("data-askuser") === "false") {
            /*                                                          */
            return;
        }

        let firstName = window.sessionStorage.getItem("promo_staticcontent_firstName");
        if (firstName !== null) {
            this.addFirstNameToDom(firstName);
            return;
        }
        const url = "/user/public/user";
        /*                                     */
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 7500);
        /*                                                                                                         */
        const headers = new Headers(window.o_promo_staticcontent && {...window.o_promo_staticcontent.headers, ...{"X-Requested-With": "XMLHttpRequest"}} || {});
        window.fetch(url, {
            headers: headers,
            method: 'GET',
            accept: 'application/json',
            signal: controller.signal
        }).then(response => {
            if (response.status === 200) {
                return response.json();
            } else {
                throw new Error("promo-aggregation: Failed to load widget");
            }
        }).then((jsonResponse) => {
            let firstName = jsonResponse.firstName;
            window.sessionStorage.setItem("promo_staticcontent_firstName", firstName);
            clearTimeout(timeoutId);
            this.addFirstNameToDom(firstName);
        }).catch(() => {
            window.sessionStorage.removeItem("promo_staticcontent_firstName");
            clearTimeout(timeoutId);
        })
    }

    addFirstNameToDom(firstName) {
        this.welcomeText.innerHTML = "Willkommen zurück, " + firstName;
    }


}